export type TGetUserInfoPayload = {
  accessToken: string | null
};

export enum FetchStatus {
  FAILURE = "failure",
  PENDING = "pending",
  SUCCESS = "success",
}
